module.exports = __webpack_public_path__ + "static/media/selectDatasetCreated.32c1621d.gif";